module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACFSURBVHgBdZBdDYAwDIQLCpCABCTgBBwgAZyAAyQgAQlI4JFkPxxdwpZtlCbNsn29tjsiIa4LtTbY3PmBSqFheHLCFSVQa7QBWuwAqgD5rXtVLtcEKovBQx6xpG0txqDUmPKdSrqpiG4gKZzSdzEGs1jEs/vfJUUP8m/GRcbiEI3yEVv9AIlrpzm74Co2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-arrow-left.png
// module id = fO/3
// module chunks = 1